import i18n from "@plugins/i18n";
import TextToSpeechModal from "@plugins/richtext/plugins/text-to-speech/components/TextToSpeechModal";
import DOMUtils from "@utils/dom.utils";
import MediaSettingsSubpage from "@/plugins/media/components/MediaSettingsSubpage.vue";
import richTextUtils from "@plugins/richtext/utils/richtext.utils";
import { MEDIA_TYPE } from "@plugins/media/media.constant";
import textToSpeechEventBus from "@plugins/richtext/plugins/text-to-speech/service/event-bus";

export default function (editor) {
  const richTextEditor = editor.options.get("richTextEditor");
  const context = richTextEditor.richTextContext;
  let modalId = null;

  (function init() {
    richTextEditor.plugins["text_to_speech"] = {
      renderInEditor,
      cleanUp,
      containPluginElements,
    };
  })();

  function cleanUp(content) {
    let containerAfterCleanUp = document.createElement("div");
    containerAfterCleanUp.innerHTML = content;

    DOMUtils.elOf(containerAfterCleanUp, ".attachment-placeholder").forEach((element) => {
      element.remove();
    });

    DOMUtils.elOf(containerAfterCleanUp, ".tts-audio-wrapper").forEach((element) => {
      element.remove();
    });

    DOMUtils.elOf(containerAfterCleanUp, ".tts-content-paragraph").forEach((element) => {
      cleanUpElement(containerAfterCleanUp, element);
    });

    DOMUtils.elOf(containerAfterCleanUp, "br[data-mce-bogus]").forEach((element) => {
      element.remove();
    });

    return containerAfterCleanUp.innerHTML;
  }

  function containPluginElements(container) {
    return container.querySelectorAll(".sls-tts").length > 0;
  }

  if (context.hasTtsAccess) {
    //renders richtext editor button
    editor.ui.registry.addButton("text_to_speech", {
      tooltip: i18n.t("tinymce_plugin_text_to_speech_button_tooltip"),
      icon: "tts",
      onAction: function () {
        openModal();
      },
    });
  }

  function openModal() {
    let textToSpeechConfig = {};
    let eventBusWatchInstances = [];
    eventBusWatchInstances.push(
      textToSpeechEventBus.$on("textToSpeechAdded", handleTextToSpeechAdded),
    );
    textToSpeechConfig.eventBusWatchInstances = eventBusWatchInstances;
    textToSpeechConfig.context = context;

    // show the modal
    modalId = richTextEditor.$modal.show(TextToSpeechModal, textToSpeechConfig, {}, true);
  }

  function openSettings(settings) {
    window.tinymce.currentEditor = editor;
    settings.editorSaveCallback = editorSaveCallback;
    richTextEditor.$contentSubpage.show(MediaSettingsSubpage, settings);
  }

  function handleTextToSpeechAdded(data) {
    richTextEditor.$modal.remove(modalId);

    richTextUtils.createInlineTextToSpeechAttachment(
      editor,
      {
        audioUuid: data.audioUuid,
        audioText: data.audioText,
      },
      { onTextToSpeechSettings: openSettings },
    );
  }

  editor.on("click", (e) => {
    let target = e.target;
    if (target.closest("button.trash") && target.closest("button.trash").length !== 0) {
      let targetNode = target.closest(".sls-tts-wrapper");
      if (targetNode) editor.execCommand("ttsDelete", targetNode);
    }
    // cater for cases when have undo action
    handlePluginRerender(target);
  });

  editor.addCommand("ttsDelete", (targetNode) => {
    richTextUtils.removeNodeFromEditor(editor, targetNode);
  });

  function renderInEditor() {
    richTextUtils.renderInlineTextToSpeech(editor, ".sls-tts", {
      onTextToSpeechSettings: openSettings,
    });
  }

  function editorSaveCallback() {
    if (window.tinymce && window.tinymce.currentEditor) {
      window.tinymce.currentEditor.save();
      delete window.tinymce.currentEditor;
    }
  }

  function cleanUpElement(container, element) {
    const ttsWrapper = element.closest(".sls-tts-wrapper");
    const audioUuid = ttsWrapper.getAttribute("data-uuid");
    let fromSE = DOMUtils.hasClass(element.closest(".tts-component"), "from-se");

    let className = fromSE ? "sls-media sls-tts from-se" : "sls-media sls-tts";
    let placeholder = DOMUtils.createElement("div", {
      class: className,
      name: "sls-media sls-tts",
      "data-type": "mo",
      "data-uuid": audioUuid,
      "media-type": MEDIA_TYPE.AUDIO,
    });

    DOMUtils.elOf(element, ".sls-tts-multiline").forEach((ele) => {
      placeholder.innerHTML = ele.outerHTML;
    });
    ttsWrapper.replaceWith(placeholder);
  }

  function handlePluginRerender(target) {
    let ttsComponent = target.closest(".tts-component");
    if (!ttsComponent || ttsComponent.length === 0 || ttsComponent.__vue__) return;

    let targetNode = ttsComponent.closest(".tts-content-paragraph");
    if (!targetNode || targetNode.length === 0) return;

    cleanUpElement(editor.getBody(), targetNode);
    renderInEditor();
  }
}
